import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import BillFormService from '../services/BillFormService';
import { BRAZIL } from '../../../core/consts';
import BillDetails from './BillDetails';

class BillDetailsContainer extends React.Component {
  static propTypes = {
    billId: PropTypes.string,
  };

  componentDidMount() {
    BillFormService.init();
    if (this.props.billId) {
      BillFormService.load(this.props.billId);
    }
  }

  render() {
    return (
      <BillDetails
        values={BillFormService.form.getValues()}
        loading={BillFormService.fetch.fetching}
        total={BillFormService.total}
        onAction={BillFormService.handleAction}
        currencyType={
          !BillFormService.form.getValue('country') || BRAZIL.includes(BillFormService.form.getValue('country'))
            ? 'real'
            : 'dollar'
        }
      />
    );
  }
}

export default observer(BillDetailsContainer);
